export default __webpack_public_path__ + "static/media/logo.ae2b82f1.svg";